export default __webpack_public_path__ + "static/media/create-stream-logo.8d5ff6f1.svg";